import React from 'react';
import './styles.scss'

const Spinner = () => <div className='loader' />;

export default Spinner;
